var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCredit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(-65 -470)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(65 470)",
    fill: "#ff4100"
  }), /*#__PURE__*/React.createElement("g", {
    id: "download_25_",
    "data-name": "download (25)",
    transform: "translate(-127.187 205.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M352.076,337.32c-.778,0-1.435,1-1.435,2.189s.657,2.189,1.435,2.189,1.435-1,1.435-2.189S352.854,337.32,352.076,337.32Z",
    transform: "translate(-144.889 -58.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M239.466,308.14H224.984a3.066,3.066,0,0,1-1.382,1.328v5.021a3.123,3.123,0,0,1,1.384,1.33h14.482a3.065,3.065,0,0,1,1.381-1.328v-5.021a3.125,3.125,0,0,1-1.384-1.331Zm-10.608,4.154H226.9a.314.314,0,1,1,0-.628h1.961a.314.314,0,1,1,0,.628Zm3.369,2.5c-1.138,0-2.063-1.264-2.063-2.817s.926-2.816,2.063-2.816,2.063,1.263,2.063,2.816S233.364,314.8,232.226,314.8Zm5.33-2.5H235.6a.314.314,0,1,1,0-.628h1.96a.314.314,0,0,1,0,.628Z",
    transform: "translate(-25.039 -31.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M216.58,274.806H197.794a.734.734,0,0,0-.733.733v9.987a.734.734,0,0,0,.733.733H216.58a.734.734,0,0,0,.733-.733v-9.987a.734.734,0,0,0-.733-.733Zm-.141,8.443a.314.314,0,0,1-.2.292,2.444,2.444,0,0,0-1.33,1.274.314.314,0,0,1-.286.185H199.751a.314.314,0,0,1-.286-.185,2.48,2.48,0,0,0-1.333-1.277.314.314,0,0,1-.2-.292v-5.431a.314.314,0,0,1,.2-.292,2.444,2.444,0,0,0,1.33-1.274.314.314,0,0,1,.286-.185h14.873a.314.314,0,0,1,.286.185,2.481,2.481,0,0,0,1.333,1.277.314.314,0,0,1,.2.292Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.dcdf766ae3311819db5d79f889963722.svg";
export { ForwardRef as ReactComponent };